import * as _ from 'lodash';
import * as moment from 'moment';
import { IAdminNotification } from '@nkr/models/index';
import { useState } from 'react';
import { Button, Glyphicon, Table } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    data: IAdminNotification[]
    showLoading: boolean,
    onMarkRead: (id: number) => void
}

const Notifications = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);
    const [currentSortBy, setCurrentSortBy] = useState('addedDateTime');
    const [currentSortDirection, setCurrentSortDirection] = useState('desc');

    const [previousSortBy, setPreviousSortBy] = useState('addedDateTime');
    const [previousSortDirection, setPreviousSortDirection] = useState('desc');

    const handleSort = (column: string, forCurrent: boolean) => {
        if (forCurrent) {
            if (currentSortBy != column) {
                setCurrentSortBy(column);
                setCurrentSortDirection('asc');
            } else {
                if (currentSortDirection == 'asc') {
                    setCurrentSortDirection('desc');
                } else {
                    setCurrentSortBy('');
                    setCurrentSortDirection('asc');
                }
            }
        } else {
            if (previousSortBy != column) {
                setPreviousSortBy(column);
                setPreviousSortDirection('asc');
            } else {
                if (previousSortDirection == 'asc') {
                    setPreviousSortDirection('desc');
                } else {
                    setPreviousSortBy('');
                    setPreviousSortDirection('asc');
                }
            }
        }
    };

    const getSortedData = (data: IAdminNotification[], forCurrent: boolean) => {
        let sortedData = _.orderBy(data, item => {
            if (forCurrent) {
                if (currentSortBy == 'addedDateTime') {
                    return moment(item.addedDateTime, 'MM/DD/YYYY HH:mm').toDate();
                }
            } else {
                if (previousSortBy == 'addedDateTime') {
                    return moment(item.addedDateTime, 'MM/DD/YYYY HH:mm').toDate();
                }
            }

            return item.description;
        }, [forCurrent ? currentSortDirection : previousSortDirection]);

        return sortedData;
    };

    const renderSortIndicator = (column: string, forCurrent: boolean) => {
        if (forCurrent) {
            if (currentSortBy == column) {
                return <Glyphicon glyph={currentSortDirection == 'asc' ? 'triangle-top' : 'triangle-bottom'} />;
            }
        }

        return null
    };

    const current = props.data.filter(x => x.isRead == false);
    const currentSortedData = getSortedData(current, true);
    const previous = props.data.filter(x => x.isRead);
    const previousSortedData = getSortedData(previous, false);

    return (
        <div className='section-notifications' style={{ marginBottom: 20 }}>
            <div className='title-container'>
                <div className='admin-title title' style={{ backgroundColor: props.showLoading ? '#eceaea' : null }} onClick={() => setExpanded(!expanded)}>
                    <h4 style={{ marginRight: 5 }}>NOTIFICATIONS <span>({current.length})</span></h4>
                    <span style={{ paddingLeft: 5, color: 'white' }}><Glyphicon glyph={expanded ? 'chevron-down' : 'chevron-up'} /></span>
                </div>
            </div>

            {expanded ?
                <div className='content' style={{ padding: 20, backgroundColor: props.showLoading ? '#eceaea' : null }}>
                    {props.showLoading && (
                        <div className="loader"><div className='message'>Checking for notifications, one moment please...</div></div>
                    )}

                    <div>
                        <h4 style={{ marginTop: 0, marginBottom: 5 }}>Current</h4>
                        <Table className='notification-table' bordered condensed striped style={{ marginBottom: 0 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#ddd' }}>
                                    <th style={{ width: '10%', cursor: 'default', borderRight: '1px solid white', textAlign: 'center' }} onClick={() => handleSort('addedDateTime', true)}>Date of<br />Notification {renderSortIndicator('addedDateTime', true)}</th>
                                    <th style={{ width: '20%', cursor: 'default', borderRight: '1px solid white', textAlign: 'center' }} onClick={() => handleSort('description', true)}>Description {renderSortIndicator('description', true)}</th>
                                    <th style={{ cursor: 'default', borderRight: '1px solid white' }} >Content</th>
                                    <th style={{ width: '10%' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {current.map((item, index) =>
                                    <tr key={'notification-' + index}>
                                        <td style={{ textAlign: 'center' }}>{item.addedDateTime}</td>
                                        <td style={{ textAlign: 'center' }}>{item.description}</td>
                                        <td>{ReactHtmlParser(item.notificationText)}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <Button bsStyle='primary' bsSize='xs' onClick={() => props.onMarkRead(item.id)}>Acknowledge</Button>
                                        </td>
                                    </tr>
                                )}

                                {currentSortedData.length == 0 && (
                                    <tr>
                                        <td colSpan={4}>
                                            At this time, there are no pending notifications
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                        <h4 style={{ marginTop: 20, marginBottom: 5 }}>Read &amp; Acknowledged</h4>
                        <Table className='notification-table' bordered condensed  striped style={{ marginBottom: 0 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#ddd' }}>
                                    <th rowSpan={2} style={{ width: '10%', cursor: 'default', borderRight: '1px solid white', textAlign: 'center' }} onClick={() => handleSort('addedDateTime', false)}>Date of<br />Notification {renderSortIndicator('addedDateTime', false)}</th>
                                    <th rowSpan={2} style={{ width: '20%', cursor: 'default', borderRight: '1px solid white', textAlign: 'center' }} onClick={() => handleSort('description', false)}>Description {renderSortIndicator('description', false)}</th>
                                    <th rowSpan={2} style={{ cursor: 'default', borderRight: '1px solid white' }}>Content</th>
                                    <th colSpan={2} style={{ textAlign: 'center', borderBottom: '1px solid white' }}>Acknowledged</th>
                                </tr>
                                <tr style={{ backgroundColor: '#ddd' }}>
                                    <th style={{ width: '10%', textAlign: 'center', borderRight: '1px solid white' }}>User</th>
                                    <th style={{ width: '10%', textAlign: 'center' }}>Date/Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {previous.map((item, index) =>
                                    <tr key={'notification-' + index}>
                                        <td style={{ textAlign: 'center' }}>{item.addedDateTime}</td>
                                        <td style={{ textAlign: 'center' }}>{item.description}</td>
                                        <td>{ReactHtmlParser(item.notificationText)}</td>
                                        <td style={{ textAlign: 'center' }}>{item.readByUser}</td>
                                        <td style={{ textAlign: 'center' }}>{item.readDateTime}</td>
                                    </tr>
                                )}

                                {previousSortedData.length == 0 && (
                                    <tr>
                                        <td colSpan={5}>
                                            There are no read notifications
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                :
                <div className='content collapsed'></div>
            }
        </div>
    );
}

export default Notifications;